import { render } from "./SubscriptionDetail.vue?vue&type=template&id=e6078620&scoped=true&ts=true"
import script from "./SubscriptionDetail.vue?vue&type=script&lang=ts"
export * from "./SubscriptionDetail.vue?vue&type=script&lang=ts"

import "./SubscriptionDetail.vue?vue&type=style&index=0&id=e6078620&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6078620"]])

export default __exports__